import React from 'react';
import PropTypes from 'prop-types';
import { Layout } from 'antd';
import { logo } from 'assets/img';
import './style.css';

const { Header: AntHeader } = Layout;

const Header = props => (
  <AntHeader>
    <div className="title-block" key="HeaderTitleBlock">
      <a href="/">
        <img alt="turing logo" className="turing-logo" src={logo} />
      </a>
      <div className="title-wrapper">
        <h1>{props.title}</h1>
      </div>
    </div>
  </AntHeader>
);

Header.defaultProps = {
  title: 'Email Communication System',
};

Header.propTypes = {
  title: PropTypes.string,
};

export default Header;
